export const CustomDesignOptions = {
    CUSTOMER: 'design.configuration'
}